module.exports = __webpack_public_path__ + "b07e9e382a585668d01ac4649870e4d3.svg";